import PropTypes from 'prop-types';
import React, { Component } from 'react';
import utils from '../../utils/utilities.js';
import FormGroup from './FormGroup.jsx';
import ChecksGroup from './ChecksGroup';

// Move to FormTypes
export const CheckOptionType = PropTypes.shape({
    label: PropTypes.any,
    value: PropTypes.any,
    extra: PropTypes.object
});

export default class SelectAllChecksGroup extends Component {

    static propTypes = {
        onChange: PropTypes.func,
        options: PropTypes.arrayOf(CheckOptionType),
        selectAll: PropTypes.any,
        classNames: PropTypes.string,
        label: PropTypes.any,
        hasError: PropTypes.any,
        disabled: PropTypes.bool,
        required: PropTypes.bool,
        fieldId: PropTypes.string
    }

    static defaultProps = {
        selectAll: null,
        label: null,
        hasError: false,
        disabled: false,
        required: false,
        classNames: "",
        fieldId: "SelectAllChecksGroup_" + utils.generateRandomHash()
    }

    constructor(props) {
        super(props);

        this.state = {
            selectedAll: !!props.selectAll
        }

        this.selectAll = this.selectAll.bind(this);
    }

    selectAll(e) {
        let newOptions = this.props.options.map(option => ({ ...option, value: true }));
        this.props.onChange(newOptions, e);
    }

    render() {
        const unselectedOptions = this.props.options.filter(option => !option.value)

        return (
            <FormGroup {...this.props} fieldId={this.props.fieldId} classNames={this.props.classNames + " checks-group"}>
                {this.props.selectAll && (
                    <div className="select-all">
                        <input
                            type="checkbox"
                            id="select-all-check"
                            checked={unselectedOptions.length === 0}
                            disabled={unselectedOptions.length === 0}
                            onChange={this.selectAll}
                        />
                        <label htmlFor="select-all-check">{this.props.selectAll}</label>
                    </div>
                )}
                <div className="checkboxes-wrapper">
                    <ChecksGroup {...this.props} />
                </div>
            </FormGroup>
        )
    }
}



// WEBPACK FOOTER //
// ./src/scripts/reusable/Form/SelectAllChecksGroup.jsx